import React from 'react';
import {
  getPagePath,
  withLocales,
  withClientConfig
} from '@spotahome/bff/client';

import {
  traditionalSignup,
  traditionalLogin,
  traditionalForgotPassword
} from '../../common/api/traditional-login-client';

const onTraditionalSignupSuccess = () => {
  location.reload();
};

const onTraditionalLoginSuccess = () => {
  location.reload();
};

const traditionalSignupCB = async (name, email, password) =>
  traditionalSignup({ name, email, password });

const traditionalLoginCB = (email, password) =>
  traditionalLogin({ email, password });

const traditionalForgotPasswordCB = async email => {
  try {
    await traditionalForgotPassword({ email });
  } catch (err) {
    console.log(err);
  }
};

const withModalProps = () => Component =>
  withClientConfig()(
    withLocales()(({ locales, clientConfig, initialAction, ...restProps }) => {
      const landlordLoginLink = getPagePath('externals.landlord-panel');
      const landlordSignupLink = getPagePath('externals.landlord-signup');

      const googleLoginHref = getPagePath('externals.social-login', {
        params: {
          social: 'google'
        },
        query: { locale: locales.current, subscribe: 'no' }
      });

      const facebookLoginHref = getPagePath('externals.social-login', {
        params: {
          social: 'facebook'
        },
        query: { locale: locales.current, subscribe: 'no' }
      });

      return (
        <Component
          {...restProps}
          modalProps={{
            landlordLoginLink,
            landlordSignupLink,
            facebookLinks: {
              login: facebookLoginHref,
              signup: facebookLoginHref
            },
            googleLinks: {
              login: googleLoginHref,
              signup: googleLoginHref
            },
            initialAction,
            termsAndConditionsLink: getPagePath(
              'externals.landing-pages.terms-and-conditions'
            ),
            traditionalSignupCB,
            traditionalLoginCB,
            forgotPasswordCB: traditionalForgotPasswordCB,
            renderTraditionalLogin: clientConfig.featureToggle.traditionalLogin,
            onTraditionalLoginSuccess,
            onTraditionalSignupSuccess
          }}
        />
      );
    })
  );

export default withModalProps;
